<!-- breadcrumb start -->
<app-breadcrumb [title]="'404 page'" [breadcrumb]="'404 page'" *ngIf="!(order$|async)"></app-breadcrumb>
<!-- breadcrumb End -->

<!-- <div *ngIf="(orderItem$|async) as  orderItems">
    <pre>
        {{orderItems |json}}
    </pre>
</div> -->

<!-- section start -->
<section class="p-0" *ngIf="!(order$|async)">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="error-section">
                    <h1>404</h1>
                    <h2>{{'page not found'|translate}}</h2>
                    <a [routerLink]="'/home'" class="btn btn-solid">{{'back to home'|translate}}</a>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Section ends -->

<!-- <div *ngIf="(order$|async) as  order">
    <pre>
        {{order | json}}
    </pre>
</div>  -->
<!-- thank-you section start -->
<section class="section-b-space light-layout" *ngIf="(order$|async) as  order">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="success-text">
                    <i class="fa fa-check-circle" aria-hidden="true"></i>
                    <h2 style="color: white;">{{'thank you'|translate}}</h2>
                    <p style="color: white;">{{'Thanks for shopping with us'|translate}}</p>
                    <p style="color: white;">{{'Order ID'|translate}}:{{ order.lastOrderId }}</p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Section ends -->

<!-- order-detail section start -->
<section class="section-b-space" *ngIf="(order$|async) as  order">
    <div class="container">

        <div class="">
            <div class="col-lg-12">
                <div class="row order-success-sec">
                    <div class="col-sm-6">
                        <h4>{{'summary'|translate}}</h4>
                        <ul class="order-detail">
                            <li>{{'order ID'|translate}}: {{ order.lastOrderId }}</li>
                            <li>{{'Order Date'|translate}}:{{order.orderDate | date:'short'}}</li>
                            <li>{{'Order Total'|translate}}: {{ totalAmount |
                                currency:productService?.Currency.currency:'symbol' }}</li>
                        </ul>
                    </div>
                    <!-- <div class="col-sm-6">
                        <h4>shipping address</h4>
                        <ul class="order-detail">
                            <li>{{ orderDetails.shippingDetails.address }}</li>
                            <li>{{ orderDetails.shippingDetails.state }}</li>
                            <li>{{ orderDetails.shippingDetails.country }}, {{ orderDetails.shippingDetails.postalcode }}</li>
                            <li>Contact No. {{ orderDetails.shippingDetails.phone }}</li>
                        </ul>
                    </div> -->

                    <!-- <div class="col-sm-12 payment-mode">
                        <h4>payment method</h4>
                        <p>Pay on Delivery (Cash/Card). Cash on delivery (COD) available. Card/Net banking acceptance subject to device availability.</p>
                    </div> -->
                    <!-- <div class="col-md-12">
                        <div class="delivery-sec">
                            <h3>We will send as soon as possible</h3> -->
                    <!-- <h2>March 21, 2021</h2> -->
                    <!-- </div>
                    </div> -->
                </div>
            </div>
            <div class="col-lg-12">
                <div class="product-order">
                    <h3>{{'your order details'|translate}}</h3>
                    <div class="row product-order-detail" *ngFor="let product of order.orderItems">
                        <div class="col-3">
                            <a [routerLink]="['/shop/product/left/sidebar/', product.barcode]">
                                <img [src]="product.productImage" alt="" class="img-fluid">
                            </a>
                        </div>
                        <div class="col-6 order_detail">
                            <div>
                                <h4>{{'Product name'|translate}}</h4>
                                <a [routerLink]="['/shop/product/left/sidebar/', product.barcode]">
                                    <h5>{{ product.productName|textLength }}</h5>
                                </a>
                            </div>
                        </div>
                        <div class="col-2 order_detail">
                            <div>
                                <h4>{{'Quantity'|translate}} </h4>
                                <h5>{{ product.quantity }} * {{ product.unitPrice | discount:product | currency:'USA' }}
                                </h5>
                            </div>
                        </div>
                        <div class="col-1 order_detail">
                            <div>
                                <h4>{{'Total'|translate}}</h4>
                                <h5> {{product.unitTotal }}</h5>
                            </div>
                        </div>
                    </div>

                    <div class="row product-order-detail" *ngIf="order.freeSample">
                        <div class="col-3">
                            <img [src]="" alt="" class="img-fluid">
                        </div>
                        <div class="col-6 order_detail">
                            <div>

                                <h5>{{'Free Sample'|translate}}</h5>
                            </div>
                        </div>
                        <div class="col-2 order_detail">
                            <div>
                                <h5>1 * $0</h5>
                            </div>
                        </div>
                        <div class="col-1 order_detail">
                            <div>
                                <h5> $0</h5>
                            </div>
                        </div>
                    </div>
                    <div class="total-sec">
                        <ul>
                            <li>{{'Delivery'|translate}} <span>{{ onTaxiAmount(order)|
                                    currency:productService?.Currency.currency:'symbol' }}</span></li>
                            <li>{{'Subtotal'|translate}} <span>{{ subTotal|
                                    currency:productService?.Currency.currency:'symbol' }}</span></li>
                            <li>{{'(Reward, Coupon)'|translate}} <span>{{ (couponAmount + reward)|
                                    currency:productService?.Currency.currency:'symbol' }}</span></li>
                            <li>{{'Tax'|translate}} <span>$00.00</span></li>
                        </ul>
                    </div>
                    <div class="final-total">
                        <h3>{{'Total'|translate}} <span>{{ totalAmount |
                                currency:productService?.Currency.currency:'symbol' }}</span></h3>
                    </div>
                </div>
            </div>


        </div>
    </div>
</section>
<!-- Section ends -->